import React from 'react';
import MUIIconButton from '@mui/material/IconButton';
import { ICON_BUTTON_TYPE } from '../constants';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ShareIcon from '@mui/icons-material/Share';
import SendIcon from '@mui/icons-material/Send';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

const IconButton = ({ onClick, type = ICON_BUTTON_TYPE.close, disabled = false, style }) => {
  return (
    <MUIIconButton style={{ border: '0.4px solid grey', ...style }} onClick={onClick} disabled={disabled}>
      {type === ICON_BUTTON_TYPE.close && <CloseIcon />}
      {type === ICON_BUTTON_TYPE.delete && <DeleteIcon style={{ color: disabled ? 'grey' : 'red' }} />}
      {type === ICON_BUTTON_TYPE.edit && <EditIcon style={{ color: disabled ? 'grey' : 'black' }} />}
      {type === ICON_BUTTON_TYPE.download && <DownloadIcon style={{ color: disabled ? 'grey' : 'black' }} />}
      {type === ICON_BUTTON_TYPE.eye && <VisibilityIcon style={{ color: disabled ? 'grey' : 'black' }} />}
      {type === ICON_BUTTON_TYPE.share && <ShareIcon style={{ color: disabled ? 'grey' : 'black' }} />}
      {type === ICON_BUTTON_TYPE.send && <SendIcon style={{ color: disabled ? 'grey' : 'black' }} />}
      {type === ICON_BUTTON_TYPE.forward && <ArrowForwardIosIcon style={{ color: disabled ? 'grey' : 'black' }} />}
      {type === ICON_BUTTON_TYPE.menu && <MenuIcon style={{ color: disabled ? 'grey' : 'black' }} />}
      {type === ICON_BUTTON_TYPE.back && <ArrowBackIosIcon style={{ color: disabled ? 'grey' : 'black' }} />}
    </MUIIconButton>
  );
};

export default IconButton;
